<footer class="footer-menu">
  <a
    *ngFor="let item of menuItems"
    [routerLink]="item.link"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="footer-item"
  >
    <mat-icon>{{ item.icon }}</mat-icon>
    <span>{{ item.label }}</span>
  </a>
</footer>